import { nextTick, ref } from "@vue/composition-api";
export const useScrollToBottom = () => {
  const scrollContainer = ref();
  const scrollToBottom = targetElementSelector => {
    nextTick(() => {
      if (targetElementSelector) {
        var _scrollContainer$valu;
        const container = (_scrollContainer$valu = scrollContainer.value) == null ? void 0 : _scrollContainer$valu.querySelector(targetElementSelector);
        if (container) {
          container.scrollTop = container.scrollHeight;
        }
      }
    });
  };
  return {
    scrollContainer,
    scrollToBottom
  };
};